var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
///<reference path='../ai-assist-base/ai-assist-base-model.d.ts'/>
import { EventHandler, Property, NotifyPropertyChanges, Collection, Event, remove, L10n, SanitizeHtmlHelper } from '@syncfusion/ej2-base';
import { ChildProperty, getUniqueID, isNullOrUndefined as isNOU, Complex, removeClass, addClass } from '@syncfusion/ej2-base';
import { Toolbar } from '@syncfusion/ej2-navigations';
import { ToolbarSettings, ToolbarItem } from '../interactive-chat-base/interactive-chat-base';
import { Uploader, SpeechToText } from '@syncfusion/ej2-inputs';
import { MarkdownConverter } from '@syncfusion/ej2-markdown-converter';
import { ButtonSettings, TooltipSettings } from '@syncfusion/ej2-inputs';
import { Fab } from '@syncfusion/ej2-buttons';
import { AIAssistBase } from '../ai-assist-base/ai-assist-base';
const ASSISTHEADER = 'e-aiassist-header-text e-assist-view-header';
/* eslint-enable @typescript-eslint/no-misused-new, no-redeclare */
/**
 * The prompts property maps the list of the prompts and binds the data to the suggestions.
 */
export class Prompt extends ChildProperty {
}
__decorate([
    Property(null)
], Prompt.prototype, "prompt", void 0);
__decorate([
    Property('')
], Prompt.prototype, "response", void 0);
__decorate([
    Property(null)
], Prompt.prototype, "isResponseHelpful", void 0);
__decorate([
    Property(null)
], Prompt.prototype, "attachedFiles", void 0);
/**
 * Specifies the type of assist view.
 */
export var AssistViewType;
(function (AssistViewType) {
    /**
     * Represents the default assist view type.
     */
    AssistViewType["Assist"] = "Assist";
    /**
     * Represents a custom assist view type.
     */
    AssistViewType["Custom"] = "Custom";
})(AssistViewType || (AssistViewType = {}));
/**
 * The assistView property maps the customized AiAssistView.
 */
export class AssistView extends ChildProperty {
}
__decorate([
    Property('Assist')
], AssistView.prototype, "type", void 0);
__decorate([
    Property('')
], AssistView.prototype, "name", void 0);
__decorate([
    Property()
], AssistView.prototype, "iconCss", void 0);
__decorate([
    Property()
], AssistView.prototype, "viewTemplate", void 0);
/**
 * Configuration settings for rendering Syncfusion Speech-to-Text in the AssistView footer.
 * This property holds the settings required to initialize and display the Speech-to-Text component.
 *
 */
export class SpeechToTextSettings extends ChildProperty {
}
__decorate([
    Property(false)
], SpeechToTextSettings.prototype, "enable", void 0);
__decorate([
    Property(true)
], SpeechToTextSettings.prototype, "allowInterimResults", void 0);
__decorate([
    Property('en-US')
], SpeechToTextSettings.prototype, "lang", void 0);
__decorate([
    Property(false)
], SpeechToTextSettings.prototype, "disabled", void 0);
__decorate([
    Complex({}, ButtonSettings)
], SpeechToTextSettings.prototype, "buttonSettings", void 0);
__decorate([
    Property(true)
], SpeechToTextSettings.prototype, "showTooltip", void 0);
__decorate([
    Complex({}, TooltipSettings)
], SpeechToTextSettings.prototype, "tooltipSettings", void 0);
__decorate([
    Property('')
], SpeechToTextSettings.prototype, "cssClass", void 0);
__decorate([
    Property('')
], SpeechToTextSettings.prototype, "transcript", void 0);
__decorate([
    Property('Inactive')
], SpeechToTextSettings.prototype, "listeningState", void 0);
__decorate([
    Event()
], SpeechToTextSettings.prototype, "onStart", void 0);
__decorate([
    Event()
], SpeechToTextSettings.prototype, "onStop", void 0);
__decorate([
    Event()
], SpeechToTextSettings.prototype, "transcriptChanged", void 0);
__decorate([
    Event()
], SpeechToTextSettings.prototype, "onError", void 0);
/**
 * Represents settings for managing file attachments in the AI Assist View.
 * Includes configuration for URLs, file types, and size limitations.
 */
export class AttachmentSettings extends ChildProperty {
}
__decorate([
    Property('')
], AttachmentSettings.prototype, "saveUrl", void 0);
__decorate([
    Property('')
], AttachmentSettings.prototype, "removeUrl", void 0);
__decorate([
    Property('')
], AttachmentSettings.prototype, "allowedFileTypes", void 0);
__decorate([
    Property(2000000)
], AttachmentSettings.prototype, "maxFileSize", void 0);
__decorate([
    Property(10)
], AttachmentSettings.prototype, "maximumCount", void 0);
__decorate([
    Event()
], AttachmentSettings.prototype, "attachmentClick", void 0);
/**
 * The promptToolbarSettings property maps the list of the promptToolbarSettings and binds the data to the prompt.
 */
export class PromptToolbarSettings extends ChildProperty {
}
__decorate([
    Property('100%')
], PromptToolbarSettings.prototype, "width", void 0);
__decorate([
    Collection([], ToolbarItem)
], PromptToolbarSettings.prototype, "items", void 0);
__decorate([
    Event()
], PromptToolbarSettings.prototype, "itemClicked", void 0);
/**
 * The responseToolbarSettings property maps the list of the responseToolbarSettings and binds the data to the output items.
 */
export class ResponseToolbarSettings extends ChildProperty {
}
__decorate([
    Property('100%')
], ResponseToolbarSettings.prototype, "width", void 0);
__decorate([
    Collection([], ToolbarItem)
], ResponseToolbarSettings.prototype, "items", void 0);
__decorate([
    Event()
], ResponseToolbarSettings.prototype, "itemClicked", void 0);
/**
 * Represents a toolbar item model in the AIAssistview component.
 */
export class FooterToolbarSettings extends ChildProperty {
}
__decorate([
    Property('Inline')
], FooterToolbarSettings.prototype, "toolbarPosition", void 0);
__decorate([
    Collection([], ToolbarItem)
], FooterToolbarSettings.prototype, "items", void 0);
__decorate([
    Event()
], FooterToolbarSettings.prototype, "itemClick", void 0);
/**
 * The `AIAssistView` component is designed to enhance user interaction by integrating AI driven assistance features.
 * It provides a seamless interface for incorporating suggestions & AI responses.
 *
 * ```html
 *  <div id='defaultAIAssistView'></div>
 * ```
 * ```typescript
 *  let aiAssistObj: AIAssistView = new AIAssistView();
 *  aiAssistObj.appendTo('#defaultAIAssistView');
 * ```
 */
let AIAssistView = class AIAssistView extends AIAssistBase {
    /**
     * Constructor for creating the component
     *
     * @param {AIAssistViewModel} options - Specifies the AIAssistViewModel model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */
    constructor(options, element) {
        super(options, element);
        this.toolbarItems = [];
        this.displayContents = [];
        this.preTagElements = [];
        this.uploadedFiles = [];
        this.sendToolbarItem = null;
        this.clearToolbarItem = null;
        this.attachmentToolbarItem = null;
        this.speechToTextToolbarItem = null;
        this.latestResponseMinHeight = null;
    }
    /**
     * Enhanced setup: Enforce viewport on .e-content + dynamic min-height on latest .e-output-container.
     * Preserves structure; only inline styles on existing elements. Scrolls to prompt top.
     * Also applies during loading by sizing the skeleton container when the final response item
     * isn't rendered yet.
     *
     * @private
     * @returns {void}
     */
    setupViewportFilling() {
        if (!this.contentWrapper || this.prompts.length === 0) {
            return;
        }
        const lastIndex = this.prompts.length - 1;
        const allResponseItems = Array.from(this.contentWrapper.querySelectorAll('.e-output-container[id^="e-response-item_"]'));
        // Set auto for all previous .e-output-container (as in example)
        for (let i = 0; i < allResponseItems.length; i++) {
            const index = parseInt(allResponseItems[i].id.split('_')[1], 10);
            if (index < lastIndex) {
                allResponseItems[i].style.minHeight = 'auto';
                const footerEle = allResponseItems[i].querySelector('.e-content-footer');
                if (footerEle) {
                    footerEle.classList.remove('e-assist-toolbar-active');
                }
            }
        }
        // Compute dynamic min-height based on viewport and fixed chrome (header/footer/paddings)
        const contentWrapperHeight = this.contentWrapper.clientHeight;
        const promptEle = this.contentWrapper.querySelector(`#e-prompt-item_${lastIndex}`);
        const promptHeight = promptEle ? promptEle.offsetHeight : 0;
        // Get the actual height of uploaded files if they exist
        const promptFilesEle = promptEle ? promptEle.querySelector('.e-prompt-uploaded-files') : null;
        const promptFilesHeight = promptFilesEle ? promptFilesEle.offsetHeight : 0;
        // Get the actual height of prompt toolbar if it exists
        const promptToolbarEle = promptEle ? promptEle.querySelector('.e-prompt-toolbar') : null;
        const promptToolbarHeight = promptToolbarEle ? promptToolbarEle.offsetHeight : 0;
        // Get the actual height of response toolbar if it exists
        const lastResponseEle = this.contentWrapper.querySelector(`#e-response-item_${lastIndex}`);
        const responseToolbarEle = lastResponseEle ? lastResponseEle.querySelector('.e-response-toolbar') : null;
        const responseToolbarHeight = responseToolbarEle ? responseToolbarEle.offsetHeight : 0;
        // Check if suggestions are visible - if so, reserve space for them
        const suggestionsHeight = (this.suggestionsElement && !this.suggestionsElement.hidden) ?
            this.suggestionsElement.offsetHeight : 0;
        let scrollToBottomBtnHeight = 0;
        if (this.downArrowIcon.element) {
            scrollToBottomBtnHeight = this.downArrowIcon.element.offsetHeight;
        }
        // Calculate minHeight to fill the content wrapper viewport completely
        const dynamicMinHeight = Math.max(160, contentWrapperHeight - promptHeight - promptFilesHeight - promptToolbarHeight -
            responseToolbarHeight - suggestionsHeight - scrollToBottomBtnHeight);
        this.latestResponseMinHeight = dynamicMinHeight;
        // Apply to the actual latest response container if available; otherwise apply to loading skeleton
        if (lastResponseEle) {
            lastResponseEle.style.minHeight = `${dynamicMinHeight}px`;
        }
        else if (this.skeletonContainer) {
            // Ensure the loader occupies the viewport so previous chats don't remain visible while loading
            this.skeletonContainer.style.minHeight = `${dynamicMinHeight}px`;
        }
    }
    renderContentElement() {
        if (this.enableScrollToBottom) {
            const scrollDownButton = this.createElement('button', { id: `${this.element.id}-scrollDownButton`, className: 'e-scroll-down-btn' });
            this.downArrowIcon = new Fab({
                iconCss: 'e-icons e-assist-scroll-down',
                position: 'BottomRight',
                target: this.outputElement.parentElement,
                isPrimary: false,
                visible: false
            });
            this.downArrowIcon.appendTo(scrollDownButton);
        }
    }
    handleScroll() {
        const atBottom = this.checkScrollAtBottom(this.contentWrapper, 50);
        this.toggleScrollIcon(atBottom);
    }
    // Toggle button visibility (show if not at bottom and enableScrollToBottom=true)
    toggleScrollIcon(atBottom) {
        if (this.isResponseRequested || !this.enableScrollToBottom || !this.downArrowIcon) {
            return;
        }
        this.downArrowIcon.visible = !atBottom;
        this.downArrowIcon.dataBind();
    }
    // Click handler to scroll to bottom
    scrollBtnClick() {
        if (this.enableScrollToBottom) {
            this.scrollToBottom();
        }
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */
    preRender() {
        if (!this.element.id) {
            this.element.id = getUniqueID('e-' + this.getModuleName());
        }
    }
    getDirective() {
        return 'EJS-AIASSISTVIEW';
    }
    /**
     * To get component name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */
    getModuleName() {
        return 'aiassistview';
    }
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @private
     * @returns {string} - It returns the persisted data.
     */
    getPersistData() {
        return this.addOnPersist([]);
    }
    render() {
        this.initializeLocale();
        this.renderPromptView();
    }
    renderPromptView() {
        this.setDimension(this.element, this.width, this.height);
        this.renderViews();
        this.renderToolbar();
        this.updateFooterElementClass();
        this.wireEvents();
    }
    renderToolbar() {
        this.updateHeaderToolbar();
        if (this.assistViewTemplateIndex < 0) {
            this.displayContents.unshift(this.contentWrapper);
        }
        else {
            this.displayContents.unshift(this.assistCustomSection);
        }
        this.previousElement = this.displayContents[this.activeView];
        this.renderHeaderToolbar();
        this.viewWrapper = this.element.querySelector('.e-view-content');
        this.updateActiveView();
        this.addCssClass(this.element, this.cssClass);
        this.updateHeader(this.showHeader, this.toolbarHeader, this.viewWrapper);
        this.aiAssistViewRendered = true;
        this.addRtlClass(this.element, this.enableRtl);
    }
    renderViews() {
        this.assistViewTemplateIndex = -1;
        this.aiAssistViewRendered = false;
        this.isAssistView = false;
        this.isOutputRenderingStop = false;
        this.isResponseRequested = false;
        this.renderViewSections(this.element, 'e-view-header', 'e-view-content');
        let isAssistViewAssigned = false;
        let assistView;
        let customViewTemplate;
        let customViewCount = 1;
        if (this.views.length > 0) {
            for (let index = 0; index < this.views.length; index++) {
                if (this.views[parseInt(index.toString(), 10)].type.toLocaleLowerCase() === 'assist' && !isAssistViewAssigned) {
                    assistView = {
                        text: this.views[parseInt(index.toString(), 10)].name || 'AI Assist',
                        prefixIcon: this.views[parseInt(index.toString(), 10)].iconCss || 'e-icons e-assistview-icon',
                        cssClass: ASSISTHEADER,
                        htmlAttributes: { 'data-index': this.element.id + '_view_0' }
                    };
                    this.toolbarItems.unshift(assistView);
                    if (this.views[parseInt(index.toString(), 10)].viewTemplate) {
                        this.assistViewTemplateIndex = index;
                    }
                    isAssistViewAssigned = true;
                    this.isAssistView = true;
                }
                else if (this.views[parseInt(index.toString(), 10)].type.toLocaleLowerCase() === 'custom') {
                    customViewTemplate = this.createElement('div', { className: 'e-customview-content-section-' + customViewCount + ' e-custom-view' });
                    this.getContextObject('customViewTemplate', customViewTemplate, -1, index);
                    this.displayContents.push(customViewTemplate);
                    this.toolbarItems.push({
                        text: this.views[parseInt(index.toString(), 10)].name || '',
                        prefixIcon: this.views[parseInt(index.toString(), 10)].iconCss || '',
                        cssClass: 'e-aiassist-header-text e-custom-view-header',
                        htmlAttributes: { 'data-index': this.element.id + '_view_' + customViewCount.toString() }
                    });
                    customViewCount++;
                }
            }
        }
        if (this.views.length === 0 || !isAssistViewAssigned) {
            assistView = {
                text: 'AI Assist',
                prefixIcon: 'e-icons e-assistview-icon',
                cssClass: ASSISTHEADER,
                htmlAttributes: { 'data-index': this.element.id + '_view_0' }
            };
            this.toolbarItems.unshift(assistView);
            isAssistViewAssigned = true;
        }
        if (this.assistViewTemplateIndex >= 0 && this.views[this.assistViewTemplateIndex].viewTemplate) {
            this.assistCustomSection = this.createElement('div', { attrs: { class: 'e-assistview-content-section', 'data-index': this.element.id + '_view_0' } });
            this.getContextObject('assistViewTemplate', this.assistCustomSection, -1, this.assistViewTemplateIndex);
        }
        else {
            this.renderDefaultView();
        }
    }
    renderHeaderToolbar() {
        this.toolbar = new Toolbar({
            items: this.toolbarItems,
            height: '100%',
            enableRtl: this.enableRtl,
            clicked: (args) => {
                const eventItemArgs = {
                    type: args.item.type,
                    text: args.item.text,
                    iconCss: args.item.prefixIcon,
                    cssClass: args.item.cssClass,
                    tooltip: args.item.tooltipText,
                    template: args.item.template,
                    disabled: args.item.disabled,
                    visible: args.item.visible,
                    align: args.item.align,
                    tabIndex: args.item.tabIndex
                };
                const eventArgs = {
                    item: eventItemArgs,
                    event: args.originalEvent,
                    cancel: false
                };
                if (this.toolbarSettings.itemClicked) {
                    this.toolbarSettings.itemClicked.call(this, eventArgs);
                }
                if (!eventArgs.cancel) {
                    if (args.item.htmlAttributes) {
                        const currentIndex = parseInt(args.item.htmlAttributes['data-index'].split(this.element.id + '_view_')[1], 10);
                        if (currentIndex !== this.activeView) {
                            const prevOnChange = this.isProtectedOnChange;
                            this.isProtectedOnChange = true;
                            const previousIndex = this.getIndex(this.activeView);
                            this.activeView = parseInt(args.item.htmlAttributes['data-index'].split(this.element.id + '_view_')[1], 10);
                            this.updateActiveView(previousIndex);
                            this.isProtectedOnChange = prevOnChange;
                        }
                    }
                }
            }
        });
        this.toolbarHeader = this.element.querySelector('.e-view-header');
        const toolbarEle = this.createElement('div');
        this.toolbar.appendTo(toolbarEle);
        this.toolbar.element.setAttribute('aria-label', 'assist-view-toolbar-header');
        this.toolbarHeader.appendChild(toolbarEle);
    }
    updateHeaderToolbar() {
        if (this.toolbarSettings.items.length > 0) {
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            const pushToolbar = this.toolbarSettings.items.map((item) => ({
                type: item.type,
                template: item.template,
                disabled: item.disabled,
                cssClass: item.cssClass,
                visible: item.visible,
                tooltipText: item.tooltip,
                prefixIcon: item.iconCss,
                text: item.text,
                align: item.align,
                tabIndex: item.tabIndex
            }));
            this.toolbarItems = [...this.toolbarItems, ...pushToolbar];
        }
    }
    getIndex(currentIndex) {
        return (((currentIndex) > (this.views.length - (this.isAssistView ? 1 : 0))) || (currentIndex < 0)) ?
            0 : currentIndex;
    }
    updateActiveView(previousIndex) {
        const activeViewIndex = this.getIndex(this.activeView);
        if (!this.aiAssistViewRendered) {
            this.appendView(activeViewIndex);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)]) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)].classList.add('e-active');
            }
        }
        else if (previousIndex !== activeViewIndex) {
            this.removePreviousView(previousIndex, activeViewIndex);
            this.appendView(activeViewIndex);
        }
        this.previousElement = this.displayContents[parseInt(activeViewIndex.toString(), 10)];
    }
    appendView(activeViewIndex) {
        //updating the new view section according to the activeView property
        if (activeViewIndex === 0 && this.assistViewTemplateIndex < 0) {
            this.viewWrapper.append(this.contentWrapper, this.footer);
        }
        else if (activeViewIndex === 0 && this.assistViewTemplateIndex >= 0) {
            this.viewWrapper.append(this.assistCustomSection);
        }
        else {
            this.viewWrapper.append(this.displayContents[parseInt(activeViewIndex.toString(), 10)]);
        }
    }
    removePreviousView(previousIndex, activeViewIndex) {
        // removing the previously binded element
        this.viewWrapper.removeChild(this.previousElement);
        if (previousIndex === 0 && this.assistViewTemplateIndex < 0) {
            this.viewWrapper.removeChild(this.footer);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)].classList.add('e-active');
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (previousIndex >= 0 && this.toolbar.tbarEle[parseInt(previousIndex.toString(), 10)]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.toolbar.tbarEle[parseInt(previousIndex.toString(), 10)].classList.remove('e-active');
        }
    }
    renderDefaultView() {
        const viewWrapper = this.element.querySelector('.e-view-content');
        this.createViewComponents(viewWrapper);
        this.contentWrapper = this.element.querySelector('.e-views');
        this.contentWrapper.setAttribute('data-index', this.element.id + '_view_0');
        const contentContainer = this.element.querySelector('.e-view-container');
        this.content = this.getElement('contentContainer');
        this.getFooter();
        this.updateFooterClass(this.footerTemplate);
        this.renderContent();
        this.renderAssistViewFooter();
        this.updateBannerView(contentContainer);
        contentContainer.append(this.content);
        this.checkIsScrollable();
    }
    checkIsScrollable() {
        if (this.enableScrollToBottom) {
            this.downArrowIcon.visible = this.contentWrapper.scrollHeight > this.contentWrapper.clientHeight;
        }
    }
    initializeLocale() {
        this.l10n = new L10n('aiassistview', {
            stopResponseText: 'Stop Responding',
            fileSizeFailure: 'Upload failed: {0} files exceeded the maximum size',
            fileCountFailure: 'Upload limit reached: Maximum {0} files allowed. Remove extra files to proceed uploading',
            send: 'Send',
            attachments: 'Attach File',
            clear: 'Clear'
        }, this.locale);
        this.l10n.setLocale(this.locale);
    }
    toggleStopRespondingButton(show) {
        const sendIconClass = 'e-assist-send';
        const stopIconClass = 'e-assist-stop';
        const stopTooltip = this.l10n.getConstant('stopResponseText');
        if (!this.footerTemplate) {
            const currentIconClass = show ? sendIconClass : stopIconClass;
            const newIconClass = show ? stopIconClass : sendIconClass;
            const currentItem = this.footerToolbarEle.items.find((item) => item.prefixIcon === `e-icons ${currentIconClass}`);
            const itemIndex = this.footerToolbarEle.items.indexOf(currentItem);
            const currentToolbarItemElement = this.footerToolbarEle.element.querySelector(`.e-tbar-btn .${currentIconClass}`) ?
                this.footerToolbarEle.element.querySelector(`.e-tbar-btn .${currentIconClass}`).closest('.e-toolbar-item') : null;
            if (itemIndex !== -1 && currentItem && currentToolbarItemElement) {
                const newItem = {
                    prefixIcon: `e-icons ${newIconClass}`,
                    align: 'Right',
                    tooltipText: show ? stopTooltip : undefined
                };
                this.footerToolbarEle.addItems([newItem], itemIndex);
                this.footerToolbarEle.removeItems(currentToolbarItemElement);
            }
            this.refreshTextareaUI();
        }
        else {
            const currentIcon = this.footer.querySelector(`.${show ? sendIconClass : stopIconClass}`);
            if (currentIcon) {
                currentIcon.classList.replace(show ? sendIconClass : stopIconClass, show ? stopIconClass : sendIconClass);
                if (show) {
                    currentIcon.title = stopTooltip;
                    EventHandler.add(currentIcon, 'click', this.respondingStopper, this);
                }
                else {
                    currentIcon.removeAttribute('title');
                    EventHandler.remove(currentIcon, 'click', this.respondingStopper);
                }
            }
        }
    }
    hasStopResponseButton() {
        if (!this.footerToolbarEle && this.footerTemplate) {
            return this.footer.querySelector('.e-assist-stop') ? true : false;
        }
        else if (this.footerToolbarEle) {
            return this.footerToolbarEle.element.querySelector('.e-assist-stop') ? true : false;
        }
        return false;
    }
    renderContent() {
        this.renderOutputContent();
        this.renderSuggestions(this.promptSuggestions, this.promptSuggestionsHeader, this.promptSuggestionItemTemplate, 'promptSuggestion', 'promptSuggestionItemTemplate', this.onSuggestionClick);
        this.renderContentElement();
        if (this.outputElement) {
            this.renderSkeleton();
        }
    }
    renderOutputContent(isMethodCall) {
        this.outputElement = this.getElement('outputElement');
        if (this.responseToolbarSettings.items.length === 0) {
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.responseToolbarSettings.items = [
                { iconCss: 'e-icons e-assist-copy', tooltip: 'Copy', cssClass: 'check' },
                { iconCss: 'e-icons e-assist-like', tooltip: 'Like' },
                { iconCss: 'e-icons e-assist-dislike', tooltip: 'Dislike' }
            ];
            this.isProtectedOnChange = prevOnChange;
        }
        if (this.prompts) {
            this.prompts.forEach((prompt, i) => {
                this.renderOutputContainer(SanitizeHtmlHelper.sanitize(prompt.prompt), SanitizeHtmlHelper.sanitize(prompt.response), prompt.attachedFiles, i, undefined, true);
            });
        }
        if (this.suggestionsElement && this.content.contains(this.suggestionsElement)) {
            this.content.insertBefore(this.outputElement, this.suggestionsElement);
        }
        else {
            this.content.appendChild(this.outputElement);
        }
        if (isMethodCall) {
            this.aiAssistViewRendered = true;
        }
    }
    updateBannerView(contentContainer) {
        if (this.prompts.length === 0) {
            this.renderBannerView(this.bannerTemplate, contentContainer, 'bannerTemplate');
        }
    }
    renderAssistViewFooter() {
        const textareaAndIconsWrapper = this.createElement('div', { attrs: { class: 'e-textarea-icons-wrapper' } });
        if (this.footerTemplate) {
            this.updateContent(this.footerTemplate, this.footer, {}, 'footerTemplate');
        }
        else {
            this.editableTextarea = this.createElement('div', {
                attrs: {
                    class: 'e-assist-textarea',
                    contenteditable: 'true',
                    placeholder: this.promptPlaceholder,
                    role: 'textbox',
                    'aria-multiline': 'true'
                },
                innerHTML: this.prompt
            });
            const hiddenTextarea = this.createElement('textarea', {
                attrs: {
                    class: 'e-hidden-textarea',
                    name: 'userPrompt',
                    value: this.prompt
                }
            });
            this.appendChildren(textareaAndIconsWrapper, this.editableTextarea, hiddenTextarea);
            this.footer.append(textareaAndIconsWrapper);
        }
        if (!this.footerTemplate) {
            const footerIconsWrapper = this.createElement('div', { attrs: { class: 'e-footer-icons-wrapper' } });
            this.renderFooterToolbar(footerIconsWrapper);
            textareaAndIconsWrapper.appendChild(footerIconsWrapper);
            this.footer.appendChild(textareaAndIconsWrapper);
            this.footer.classList.add('e-footer-focus-wave-effect');
            this.refreshTextareaUI();
            this.pushToUndoStack(this.prompt);
        }
    }
    renderFooterToolbar(container) {
        const toolbarItems = [];
        const customItems = this.footerToolbarSettings.items || [];
        for (const customItem of customItems) {
            const isSttToolbarItem = customItem.iconCss.indexOf('e-assist-speech-to-text') !== -1;
            const mappedItem = {
                type: customItem.type,
                template: isSttToolbarItem && isNOU(customItem.template) ? '<button class="e-assistview-speech-to-text e-tbar-btn"></button>' : customItem.template,
                disabled: customItem.disabled,
                cssClass: customItem.cssClass,
                visible: customItem.visible,
                tooltipText: customItem.tooltip,
                prefixIcon: customItem.iconCss,
                text: customItem.text,
                align: customItem.align,
                tabIndex: customItem.tabIndex
            };
            toolbarItems.push(mappedItem);
        }
        if (this.enableAttachments && !this.isDuplicatedItem('e-icons e-assist-attachment-icon', toolbarItems)) {
            this.attachmentToolbarItem = {
                prefixIcon: 'e-icons e-assist-attachment-icon',
                tooltipText: this.l10n.getConstant('attachments'),
                align: 'Right'
            };
            toolbarItems.push(this.attachmentToolbarItem);
        }
        if (this.speechToTextSettings.enable && !this.isDuplicatedItem('e-icons e-assist-speech-to-text', toolbarItems)) {
            this.speechToTextToolbarItem = {
                id: this.element.id + '_speechtotext',
                template: '<button class="e-assistview-speech-to-text"></button>',
                prefixIcon: 'e-icons e-assist-speech-to-text',
                align: 'Right'
            };
            toolbarItems.push(this.speechToTextToolbarItem);
        }
        if (this.showClearButton && !this.isDuplicatedItem('e-icons e-assist-clear-icon', toolbarItems)) {
            this.clearToolbarItem = {
                prefixIcon: 'e-icons e-assist-clear-icon',
                tooltipText: this.l10n.getConstant('clear'),
                align: 'Right'
            };
            toolbarItems.push(this.clearToolbarItem);
        }
        if (!this.isDuplicatedItem('e-icons e-assist-send', toolbarItems)) {
            this.sendToolbarItem = {
                prefixIcon: 'e-icons e-assist-send',
                align: 'Right'
            };
            toolbarItems.push(this.sendToolbarItem);
        }
        this.footerToolbarEle = new Toolbar({
            items: toolbarItems,
            enableRtl: this.enableRtl,
            width: '100%',
            clicked: (args) => {
                const eventItemArgs = {
                    type: args.item.type,
                    text: args.item.text,
                    iconCss: args.item.prefixIcon,
                    cssClass: args.item.cssClass,
                    tooltip: args.item.tooltipText,
                    template: args.item.template,
                    disabled: args.item.disabled,
                    visible: args.item.visible,
                    align: args.item.align,
                    tabIndex: args.item.tabIndex
                };
                const eventArgs = {
                    item: eventItemArgs,
                    event: args.originalEvent,
                    cancel: false
                };
                if (this.footerToolbarSettings.itemClick) {
                    this.footerToolbarSettings.itemClick.call(this, eventArgs);
                }
                if (!eventArgs.cancel) {
                    switch (args.item.prefixIcon) {
                        case 'e-icons e-assist-send':
                            if (!this.isResponseRequested && !args.item.disabled) {
                                this.onSendIconClick();
                            }
                            break;
                        case 'e-icons e-assist-stop':
                            this.respondingStopper(args.originalEvent);
                            break;
                        case 'e-icons e-assist-clear-icon':
                            this.clearIconHandler();
                            break;
                        case 'e-icons e-assist-attachment-icon':
                            if (this.uploaderObj && this.attachmentToolbarItem) {
                                let uploaderElement = this.footerToolbarEle.element.querySelector('.e-assist-file-upload');
                                if (!uploaderElement) {
                                    this.updateAttachmentElement();
                                    uploaderElement = this.footerToolbarEle.element.querySelector('.e-assist-file-upload');
                                }
                                if (uploaderElement) {
                                    uploaderElement.click();
                                }
                            }
                            break;
                    }
                }
            }
        });
        const toolbarContainer = this.createElement('div');
        this.footerToolbarEle.appendTo(toolbarContainer);
        this.footerToolbarEle.element.setAttribute('aria-label', 'assist-footer-toolbar');
        container.appendChild(toolbarContainer);
        this.updateAttachmentElement();
        this.renderSpeechToText();
    }
    isDuplicatedItem(iconCss, toolbarItems) {
        for (const item of toolbarItems) {
            if ((item.prefixIcon || '') === iconCss) {
                switch (iconCss) {
                    case 'e-icons e-assist-send':
                        this.sendToolbarItem = item;
                        break;
                    case 'e-icons e-assist-clear-icon':
                        this.clearToolbarItem = item;
                        break;
                    case 'e-icons e-assist-attachment-icon':
                        this.attachmentToolbarItem = item;
                        break;
                }
                return true;
            }
        }
        return false;
    }
    updateAttachmentElement() {
        if (this.enableAttachments && this.attachmentToolbarItem) {
            this.renderAttachmentIcon();
        }
        else {
            if (this.uploaderObj) {
                this.uploaderObj.destroy();
                this.dropArea.innerHTML = '';
                remove(this.dropArea);
            }
        }
    }
    renderSpeechToText() {
        if (this.speechToTextObj) {
            this.speechToTextObj.destroy();
            this.speechToTextObj = null;
        }
        if (this.speechToTextSettings.enable) {
            this.speechToTextObj = new SpeechToText({
                allowInterimResults: this.speechToTextSettings.allowInterimResults,
                transcript: this.speechToTextSettings.transcript,
                lang: this.speechToTextSettings.lang,
                listeningState: this.speechToTextSettings.listeningState,
                disabled: this.speechToTextSettings.disabled,
                buttonSettings: this.speechToTextSettings.buttonSettings,
                showTooltip: this.speechToTextSettings.showTooltip,
                tooltipSettings: this.speechToTextSettings.tooltipSettings,
                cssClass: this.speechToTextSettings.cssClass,
                onStart: (args) => {
                    if (this.speechToTextSettings.onStart) {
                        this.speechToTextSettings.onStart.call(this, args);
                    }
                },
                onStop: (args) => {
                    if (this.speechToTextSettings.onStop) {
                        this.speechToTextSettings.onStop.call(this, args);
                    }
                },
                transcriptChanged: (args) => {
                    const prevOnChange = this.isProtectedOnChange;
                    this.isProtectedOnChange = true;
                    const value = this.prompt.length > 0 ? this.prompt + ' ' : '';
                    if (args.isInterimResult) {
                        this.editableTextarea.innerHTML = value + SanitizeHtmlHelper.sanitize(args.transcript);
                    }
                    else {
                        const prevPrompt = this.prompt;
                        this.prompt = value + SanitizeHtmlHelper.sanitize(args.transcript);
                        this.editableTextarea.innerHTML = this.prompt;
                        this.speechToTextObj.transcript = '';
                        this.editableTextarea.focus();
                        this.setFocusAtEnd(this.editableTextarea);
                        this.triggerPromptChanged(event, prevPrompt);
                    }
                    this.refreshTextareaUI();
                    // Debounced push to undo stack
                    this.scheduleUndoPush();
                    this.redoStack = [];
                    this.speechToTextSettings.transcript = args.transcript;
                    if (this.speechToTextSettings.transcriptChanged) {
                        this.speechToTextSettings.transcriptChanged.call(this, args);
                    }
                    this.isProtectedOnChange = prevOnChange;
                },
                onError: (args) => {
                    if (this.speechToTextSettings.onError) {
                        this.speechToTextSettings.onError.call(this, args);
                    }
                }
            });
            const speechToTextButton = this.footerToolbarEle.element.querySelector('.e-assistview-speech-to-text');
            if (speechToTextButton) {
                this.speechToTextObj.appendTo(speechToTextButton);
            }
        }
    }
    renderAttachmentIcon() {
        this.dropArea = this.createElement('div', { attrs: { class: 'e-assist-drop-area' } });
        this.footer.prepend(this.dropArea);
        const attachmentIcon = this.footerToolbarEle.element.querySelector('.e-assist-attachment-icon');
        const uploaderElement = this.createElement('input', { attrs: { class: 'e-assist-file-upload', type: 'file', name: 'UploadFiles', id: 'fileUpload' } });
        attachmentIcon.appendChild(uploaderElement);
        this.uploaderObj = new Uploader({
            asyncSettings: {
                saveUrl: this.attachmentSettings.saveUrl,
                removeUrl: this.attachmentSettings.removeUrl
            },
            maxFileSize: this.attachmentSettings.maxFileSize,
            allowedExtensions: this.attachmentSettings.allowedFileTypes,
            progress: this.onUploadProgress.bind(this),
            success: this.onUploadSuccess.bind(this),
            failure: this.onUploadFailure.bind(this),
            uploading: this.onUploadStart.bind(this),
            multiple: true,
            selected: (args) => {
                const oversized = args.filesData.filter((file) => file.status === this.uploaderObj.l10n.getConstant('invalidMaxFileSize') && file.statusCode === '0');
                if (oversized.length) {
                    this.showFailureAlert('fileSizeFailure', oversized.length, 'e-size-failure');
                    uploaderElement.value = '';
                }
                const totalSelected = args.filesData.length + this.uploadedFiles.length;
                if (totalSelected > this.attachmentSettings.maximumCount) {
                    args.cancel = true;
                    this.showFailureAlert('fileCountFailure', this.attachmentSettings.maximumCount, 'e-count-failure');
                    uploaderElement.value = '';
                    return;
                }
            }
        });
        this.uploaderObj.appendTo(uploaderElement);
    }
    showFailureAlert(localeConstantKey, fileCount, failureType) {
        let failureMessage = this.l10n.getConstant(localeConstantKey).replace('{0}', fileCount.toString());
        if (fileCount === 1) {
            failureMessage = failureMessage.replace('files', 'file');
        }
        this.createFailureAlert(failureMessage, failureType);
    }
    createFailureAlert(failureMessage, failureType) {
        const failureAlert = this.renderFailureAlert(this.viewWrapper, failureMessage, failureType, 'e-assist-circle-close', 'e-assist-clear-icon');
        if (this.viewWrapper.contains(this.footer)) {
            this.viewWrapper.insertBefore(failureAlert, this.footer);
        }
        failureAlert.classList.add('e-show');
        setTimeout(() => {
            this.handleFailureAlertRemove(this.viewWrapper, failureAlert);
        }, 3000);
    }
    onUploadStart(args) {
        this.trigger('beforeAttachmentUpload', args);
        this.uploadedFiles.push(args.fileData);
        const fileItem = this.createFileItem(args.fileData, true);
        this.dropArea.appendChild(fileItem);
    }
    onUploadProgress(args) {
        const uploadProgress = args.e.loaded / args.e.total * 100;
        const progressFill = this.footer.querySelector(`#e-assist-progress-${CSS.escape(args.file.name)}`);
        if (progressFill) {
            progressFill.style.width = `${uploadProgress}%`;
        }
    }
    onUploadSuccess(args) {
        if (args.operation === 'upload') {
            this.trigger('attachmentUploadSuccess', args);
            const progressFill = this.footer.querySelector(`#e-assist-progress-${CSS.escape(args.file.name)}`);
            if (progressFill) {
                progressFill.style.width = '100%';
                this.cleanupFileItem(args.file.name);
            }
            const progressBar = this.footer.querySelector('.e-assist-progress-fill');
            if (!progressBar) {
                this.checkAndActivateSendIcon();
            }
        }
        else if (args.operation === 'remove') {
            this.trigger('attachmentRemoved', args);
        }
    }
    cleanupFileItem(fileName) {
        const fileItem = this.footer.querySelector(`#e-assist-progress-${CSS.escape(fileName)}`);
        if (fileItem) {
            fileItem.parentElement.remove();
        }
    }
    onUploadFailure(args) {
        if (args.operation === 'remove') {
            this.trigger('attachmentRemoved', args);
        }
        else {
            this.trigger('attachmentUploadFailure', args);
            this.uploaderObj.remove(args.file);
            this.uploadedFiles = this.uploadedFiles.filter((file) => file.name !== args.file.name);
            const progressFill = this.footer.querySelector(`#e-assist-progress-${CSS.escape(args.file.name)}`);
            if (progressFill) {
                progressFill.style.width = '100%';
                progressFill.classList.add('e-assist-upload-failed');
            }
        }
    }
    createFileItem(fileData, isForFooter) {
        const fileItem = this.createElement('div', { className: 'e-assist-uploaded-file-item' });
        const fileIcon = this.createElement('div', { className: 'e-icons e-assist-file-format-icon' });
        const fileDetails = this.createElement('div', { className: 'e-assist-file-details' });
        const fileName = this.createElement('span', { className: 'e-assist-file-name', innerHTML: fileData.name });
        const fileSize = this.createElement('span', { className: 'e-assist-file-size', innerHTML: `${(fileData.size / 1024).toFixed(2)} KB` });
        const progressBar = this.createElement('div', { className: 'e-assist-progress-bar' });
        const progressFill = this.createElement('div', { id: `e-assist-progress-${fileData.name}`, className: 'e-assist-progress-fill' });
        progressBar.appendChild(progressFill);
        fileDetails.append(fileName, fileSize);
        fileItem.append(fileIcon, fileDetails);
        let closeButton;
        if (isForFooter) {
            closeButton = this.createElement('span', { attrs: { class: 'e-icons e-assist-clear-icon', role: 'button', 'aria-label': 'Clear file', tabindex: '-1' } });
            EventHandler.add(closeButton, 'click', () => this.handleRemoveUploadedFile(closeButton, fileData, fileItem));
            fileItem.append(closeButton);
        }
        fileItem.append(progressBar);
        EventHandler.add(fileItem, 'click', (event) => {
            if (closeButton && (event.target === closeButton || event.target.classList.contains('e-assist-clear-icon'))) {
                return;
            }
            this.handleAttachmentPreview(fileData);
        });
        return fileItem;
    }
    handleAttachmentPreview(file) {
        const eventArgs = {};
        if (this.attachmentSettings.attachmentClick) {
            this.attachmentSettings.attachmentClick.call(this, eventArgs);
        }
    }
    handleRemoveUploadedFile(closeButton, fileData, fileItem) {
        this.uploaderObj.remove(fileData);
        this.uploadedFiles = this.uploadedFiles.filter((file) => file.name !== fileData.name);
        EventHandler.remove(closeButton, 'click', this.handleRemoveUploadedFile);
        fileItem.remove();
        this.checkAndActivateSendIcon();
    }
    applyPromptChange(newState, oldState, event) {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.prompt = this.editableTextarea.innerHTML = newState.content;
        this.isProtectedOnChange = prevOnChange;
        this.refreshTextareaUI();
        this.setCursorPosition(newState.selectionStart, newState.selectionEnd);
        this.triggerPromptChanged(event, oldState.content);
    }
    handleInput(event) {
        const textareaEle = event.target;
        const isEmpty = textareaEle.innerHTML === '<br>';
        if (isEmpty) {
            this.clearBreakTags(textareaEle);
        }
        const textContent = textareaEle.innerHTML;
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        const prevPrompt = this.prompt;
        this.prompt = SanitizeHtmlHelper.sanitize(textContent);
        this.isProtectedOnChange = prevOnChange;
        this.refreshTextareaUI();
        this.editableTextarea.focus();
        // Debounced push to undo stack
        this.scheduleUndoPush();
        this.redoStack = [];
        this.triggerPromptChanged(event, prevPrompt);
    }
    triggerPromptChanged(event, prevPrompt) {
        const eventArgs = {
            value: this.prompt,
            previousValue: prevPrompt,
            event: event,
            element: (event && event.currentTarget) || this.editableTextarea
        };
        this.trigger('promptChanged', eventArgs);
    }
    footerKeyHandler(e) {
        const targetElement = e.target;
        if (targetElement.classList.contains('e-tbar-btn') && targetElement.querySelector('.e-assist-attachment-icon')) {
            return;
        }
        this.keyHandler(e, 'footer');
    }
    bindScroll() {
        if (this.contentWrapper) {
            EventHandler.add(this.contentWrapper, 'scroll', this.handleScroll, this);
        }
        if (this.enableScrollToBottom && this.downArrowIcon && this.downArrowIcon.element) {
            EventHandler.add(this.downArrowIcon.element, 'click', this.scrollBtnClick, this);
        }
    }
    unBindScroll() {
        if (this.contentWrapper) {
            EventHandler.remove(this.contentWrapper, 'scroll', this.handleScroll);
        }
        if (this.enableScrollToBottom && this.downArrowIcon && this.downArrowIcon.element) {
            EventHandler.remove(this.downArrowIcon.element, 'click', this.scrollBtnClick);
        }
    }
    wireEvents() {
        this.wireFooterEvents(this.footerTemplate);
        if (this.editableTextarea) {
            const footerIconsWrapper = this.footer.querySelector('.e-footer-icons-wrapper');
            if (footerIconsWrapper) {
                EventHandler.add(footerIconsWrapper, 'pointerdown', this.onFooterIconsPointerDown, this);
                // Optional fallback for environments without Pointer Events
                EventHandler.add(footerIconsWrapper, 'click', this.onFooterIconsClick, this);
                EventHandler.add(footerIconsWrapper, 'focusout', this.onFooterIconsFocusOut, this);
            }
        }
        if (this.enableScrollToBottom) {
            this.bindScroll();
        }
    }
    unWireEvents() {
        this.unWireFooterEvents(this.footerTemplate);
        if (this.editableTextarea) {
            const footerIconsWrapper = this.footer.querySelector('.e-footer-icons-wrapper');
            if (footerIconsWrapper) {
                EventHandler.remove(footerIconsWrapper, 'pointerdown', this.onFooterIconsPointerDown);
                EventHandler.remove(footerIconsWrapper, 'click', this.onFooterIconsClick);
                EventHandler.remove(footerIconsWrapper, 'focusout', this.onFooterIconsFocusOut);
            }
        }
        this.detachCodeCopyEventHandler();
        this.unBindScroll();
    }
    onFocusEditableTextarea() {
        if (this.footer) {
            this.footer.classList.add('e-footer-focused');
        }
        this.toggleClearIcon();
    }
    onBlurEditableTextarea(e) {
        const relatedTargetEle = e.relatedTarget;
        if (relatedTargetEle && relatedTargetEle.closest('.e-toolbar')) {
            return;
        }
        if (!relatedTargetEle) {
            if (this.footer) {
                this.footer.classList.remove('e-footer-focused');
            }
            if (this.clearToolbarItem) {
                this.toggleClearIcon();
            }
        }
        else {
            if (this.clearToolbarItem) {
                if (relatedTargetEle && !(relatedTargetEle.querySelector('.e-assist-clear-icon'))) {
                    this.toggleClearIcon();
                }
            }
            if (this.footer) {
                this.footer.classList.remove('e-footer-focused');
            }
        }
    }
    detachCodeCopyEventHandler() {
        this.preTagElements.forEach(({ preTag, handler }) => {
            const copyIcon = preTag.querySelector('.e-code-copy');
            EventHandler.remove(copyIcon, 'click', handler);
        });
        this.preTagElements = [];
    }
    keyHandler(event, value) {
        if (event.key === 'Enter' && !event.shiftKey) {
            switch (value) {
                case 'footer':
                    this.pushToUndoStack(this.editableTextarea.innerText);
                    event.preventDefault();
                    if (!this.isResponseRequested) {
                        this.onSendIconClick();
                    }
                    else if (this.isResponseRequested && this.hasStopResponseButton()) {
                        this.respondingStopper(event);
                    }
                    break;
            }
        }
        else if (event.key === 'Backspace' || event.key === 'Delete') {
            if (this.speechToTextObj) {
                this.speechToTextObj.transcript = '';
            }
        }
        else {
            this.handleUndoRedo(event);
        }
    }
    clearIconHandler() {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.editableTextarea.innerText = this.prompt = '';
        if (this.speechToTextObj) {
            this.speechToTextObj.transcript = '';
        }
        this.isProtectedOnChange = prevOnChange;
        this.refreshTextareaUI();
        this.editableTextarea.focus();
        this.pushToUndoStack(this.prompt);
        this.checkAndActivateSendIcon();
    }
    respondingStopper(event) {
        this.isOutputRenderingStop = true;
        this.isResponseRequested = false;
        this.lastStreamPrompt = '';
        if (this.outputElement.hasChildNodes) {
            const skeletonElement = this.element.querySelector('.e-loading-body');
            if (skeletonElement) {
                this.outputElement.removeChild(this.skeletonContainer);
            }
        }
        this.toggleStopRespondingButton(false);
        const promptIndex = this.prompts ? this.prompts.length - 1 : -1;
        const eventArgs = {
            event: event,
            prompt: promptIndex >= 0 ? this.prompts[parseInt(promptIndex.toString(), 10)].prompt : '',
            dataIndex: this.prompts ? this.prompts.length - 1 : -1
        };
        this.trigger('stopRespondingClick', eventArgs);
        const outputContainer = this.element.querySelector(`#e-response-item_${promptIndex}`);
        if (outputContainer) {
            const outputContentBodyEle = this.element.querySelector(`#e-response-item_${this.prompts.length - 1}`).querySelector('.e-content-body');
            if (outputContentBodyEle) {
                this.renderPreTag(outputContentBodyEle);
            }
        }
    }
    onSuggestionClick(e, suggestion) {
        this.suggestionsElement.hidden = true;
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        // Prefer the passed-in canonical suggestion; fall back to event target text if absent
        this.prompt = !isNOU(suggestion) ? suggestion : e.target.innerText;
        this.isProtectedOnChange = prevOnChange;
        this.onSendIconClick();
    }
    onSendIconClick() {
        if (this.isResponseRequested || !(this.prompt.trim() || this.uploadedFiles.length)) {
            return;
        }
        if (!isNOU(this.speechToTextObj)) {
            this.speechToTextObj.stopListening();
        }
        this.isResponseRequested = true;
        this.lastStreamPrompt = '';
        if (this.suggestionsElement) {
            this.suggestionsElement.hidden = true;
        }
        this.isOutputRenderingStop = false;
        this.toggleStopRespondingButton(true);
        this.addPrompt();
        if (this.prompts.length === 1) {
            this.updateBannerTemplate('');
        }
        this.createOutputElement();
        const eventArgs = {
            cancel: false,
            responseToolbarItems: this.responseToolbarSettings.items,
            prompt: this.prompt,
            promptSuggestions: this.promptSuggestions,
            attachedFiles: [...this.uploadedFiles]
        };
        this.clearUploadedFiles();
        if (!this.footerTemplate) {
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.prompt = this.editableTextarea.innerText = '';
            this.isProtectedOnChange = prevOnChange;
            this.refreshTextareaUI();
            this.pushToUndoStack(this.prompt);
        }
        this.setupViewportFilling();
        this.trigger('promptRequest', eventArgs);
        if (this.contentWrapper) {
            this.scrollToBottom();
        }
    }
    clearUploadedFiles() {
        this.uploadedFiles = [];
        if (this.dropArea) {
            this.dropArea.innerHTML = '';
        }
    }
    addPrompt() {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.prompts = [...this.prompts, { prompt: this.prompt, response: '', isResponseHelpful: null, attachedFiles: this.uploadedFiles }];
        this.isProtectedOnChange = prevOnChange;
    }
    getContextObject(templateName, contentElement, index, arrayPosition) {
        let template;
        let context = {};
        const contextIndex = index >= 0 ? index : -1;
        const contextPrompt = index >= 0 ? this.prompts[parseInt(contextIndex.toString(), 10)].prompt : '';
        const contextOutput = index >= 0 ? this.prompts[parseInt(contextIndex.toString(), 10)].response : '';
        switch (templateName.toLowerCase()) {
            case 'promptitemtemplate': {
                template = this.promptItemTemplate;
                context = {
                    prompt: contextPrompt,
                    toolbarItems: this.promptToolbarSettings.items,
                    index: contextIndex,
                    attachedFiles: this.uploadedFiles
                };
                break;
            }
            case 'responseitemtemplate': {
                template = this.responseItemTemplate;
                context = {
                    prompt: contextPrompt,
                    response: contextOutput,
                    index: contextIndex,
                    toolbarItems: this.responseToolbarSettings.items
                };
                break;
            }
            case 'customviewtemplate':
            case 'assistviewtemplate': {
                template = this.views[parseInt(arrayPosition.toString(), 10)].viewTemplate || '';
                break;
            }
        }
        this.updateContent(template, contentElement, context, templateName);
    }
    createOutputElement() {
        this.outputSuggestionEle = this.createElement('div', { attrs: { id: `e-prompt-item_${this.prompts.length - 1}`, class: `e-prompt-container ${this.promptItemTemplate ? 'e-prompt-item-template' : ''}` } });
        this.renderPrompt(this.prompt, this.prompts.length - 1, this.uploadedFiles);
        this.outputElement.append(this.outputSuggestionEle, this.skeletonContainer);
        this.skeletonContainer.hidden = false;
    }
    renderOutputContainer(promptText, outputText, attachedFiles, index, isMethodCall, isFinalUpdate) {
        const outputContainer = this.createElement('div', { attrs: Object.assign({ id: `e-response-item_${index}`, class: `e-output-container ${this.responseItemTemplate ? 'e-response-item-template' : ''}` }, (this.latestResponseMinHeight != null ?
                { style: `min-height:${this.latestResponseMinHeight}px` } : {})) });
        this.renderOutput(outputContainer, promptText, outputText, attachedFiles, isMethodCall, index, isFinalUpdate);
        if (promptText) {
            this.outputElement.append(this.outputSuggestionEle);
        }
        this.outputElement.append(outputContainer);
        if (this.hasStopResponseButton() && isFinalUpdate) {
            this.toggleStopRespondingButton(false);
        }
        if (!this.isOutputRenderingStop && !this.content.contains(this.suggestionsElement) && this.suggestionsElement) {
            this.content.append(this.suggestionsElement);
        }
    }
    renderOutput(outputContainer, promptText, outputText, attachedFiles, isMethodCall, index, isFinalUpdate) {
        const promptIcon = this.createElement('span', {
            className: 'e-output-icon e-icons ' + (this.responseIconCss || (this.isAssistView && this.views[0].iconCss) || 'e-assistview-icon')
        });
        const aiOutputEle = this.createElement('div', { className: 'e-output' });
        if (!this.aiAssistViewRendered || isMethodCall) {
            if (!isNOU(promptText) || (attachedFiles && attachedFiles.length > 0)) {
                this.outputSuggestionEle = this.createElement('div', { attrs: { id: `e-prompt-item_${index}`, class: `e-prompt-container ${this.promptItemTemplate ? 'e-prompt-item-template' : ''}` } });
                this.renderPrompt(promptText, index, attachedFiles);
            }
        }
        const lastPrompt = { prompt: promptText, response: outputText };
        if (lastPrompt.response) {
            if (this.responseItemTemplate) {
                this.getContextObject('responseItemTemplate', aiOutputEle, index);
                if (this.outputElement.querySelector('.e-skeleton')) {
                    this.outputElement.removeChild(this.skeletonContainer);
                }
                if (this.contentFooterEle) {
                    this.contentFooterEle.classList.remove('e-assist-toolbar-active');
                }
                this.renderOutputToolbarItems(index, isFinalUpdate);
                aiOutputEle.append(this.contentFooterEle);
                outputContainer.append(aiOutputEle);
            }
            else {
                this.renderOutputTextContainer(lastPrompt.response, aiOutputEle, index, false, isFinalUpdate);
                outputContainer.append(promptIcon, aiOutputEle);
            }
        }
        else if (this.aiAssistViewRendered) {
            if (this.outputElement.querySelector('.e-skeleton')) {
                this.outputElement.removeChild(this.skeletonContainer);
            }
            if (this.suggestionsElement) {
                this.suggestionsElement.hidden = false;
            }
        }
    }
    renderOutputTextContainer(response, aiOutputEle, index, isMethodCall, isFinalUpdate) {
        if (this.contentFooterEle) {
            this.contentFooterEle.classList.remove('e-assist-toolbar-active');
        }
        this.outputContentBodyEle = this.createElement('div', { attrs: { class: 'e-content-body', tabindex: '0' } });
        if (!isMethodCall) {
            if (!this.enableStreaming || isFinalUpdate) {
                const htmlResponse = MarkdownConverter.toHtml(response);
                this.outputContentBodyEle.innerHTML = htmlResponse;
            }
            else {
                this.outputContentBodyEle.innerHTML = response;
            }
            if (isFinalUpdate) {
                this.renderPreTag(this.outputContentBodyEle);
            }
        }
        if (this.outputElement.querySelector('.e-skeleton')) {
            this.outputElement.removeChild(this.skeletonContainer);
        }
        this.appendChildren(aiOutputEle, this.outputContentBodyEle);
        if (isFinalUpdate) {
            this.renderOutputToolbarItems(index, isFinalUpdate);
            this.appendChildren(aiOutputEle, this.contentFooterEle);
        }
    }
    renderPreTag(outputContentEle) {
        const preTags = Array.from(outputContentEle.querySelectorAll('pre'));
        preTags.forEach((preTag) => {
            const copyIcon = document.createElement('span');
            copyIcon.className = 'e-icons e-code-copy e-assist-copy';
            preTag.insertBefore(copyIcon, preTag.firstChild);
            this.preTagElements.push({ preTag, handler: this.getCopyHandler(preTag) });
            EventHandler.add(copyIcon, 'click', this.preTagElements[this.preTagElements.length - 1].handler);
        });
    }
    getCopyHandler(preTag) {
        return function () {
            const preText = preTag.innerText;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.navigator.clipboard.writeText(preText);
            const copyIcon = preTag.querySelector('.e-code-copy');
            copyIcon.className = 'e-icons e-code-copy e-assist-check';
            setTimeout(() => {
                copyIcon.className = 'e-icons e-code-copy e-assist-copy';
            }, 1000);
        };
    }
    renderOutputToolbarItems(index, isFinalUpdate) {
        this.contentFooterEle = this.createElement('div', { className: 'e-content-footer e-assist-toolbar-active' });
        const footerContent = this.createElement('div');
        this.renderResponseToolbar(index);
        if (this.aiAssistViewRendered) {
            if (this.outputElement.querySelector('.e-skeleton')) {
                this.outputElement.removeChild(this.skeletonContainer);
            }
            if (isFinalUpdate && this.suggestionsElement) {
                this.suggestionsElement.hidden = false;
            }
        }
        this.responseToolbarEle.appendTo(footerContent);
        this.responseToolbarEle.element.setAttribute('aria-label', `response-toolbar-${index}`);
        this.contentFooterEle.appendChild(footerContent);
    }
    renderResponseToolbar(index) {
        const pushToolbar = this.responseToolbarSettings.items.map((item) => {
            const toolbarItem = {
                type: item.type,
                visible: item.visible,
                disabled: item.disabled,
                tooltipText: item.tooltip,
                template: item.template,
                prefixIcon: item.iconCss,
                text: item.text,
                cssClass: item.cssClass,
                align: item.align,
                width: this.responseToolbarSettings.width,
                tabIndex: item.tabIndex
            };
            if (toolbarItem.prefixIcon === 'e-icons e-assist-like' && this.prompts[parseInt(index.toString(), 10)].isResponseHelpful) {
                toolbarItem.prefixIcon = 'e-icons e-assist-like-filled';
            }
            else if (toolbarItem.prefixIcon === 'e-icons e-assist-dislike' && this.prompts[parseInt(index.toString(), 10)].isResponseHelpful === false) {
                toolbarItem.prefixIcon = 'e-icons e-assist-dislike-filled';
            }
            return toolbarItem;
        });
        this.responseToolbarEle = new Toolbar({
            items: pushToolbar,
            clicked: (args) => {
                const eventItemArgs = {
                    type: args.item.type,
                    text: args.item.text,
                    iconCss: args.item.prefixIcon,
                    cssClass: args.item.cssClass,
                    tooltip: args.item.tooltipText,
                    template: args.item.template,
                    disabled: args.item.disabled,
                    visible: args.item.visible,
                    align: args.item.align,
                    tabIndex: args.item.tabIndex
                };
                const eventArgs = {
                    item: eventItemArgs,
                    event: args.originalEvent,
                    cancel: false,
                    dataIndex: index
                };
                if (this.responseToolbarSettings.itemClicked) {
                    this.responseToolbarSettings.itemClicked.call(this, eventArgs);
                }
                if (!eventArgs.cancel) {
                    this.handleItemClick(args, index);
                }
            }
        });
    }
    handleItemClick(args, index) {
        if (args.item.prefixIcon === 'e-icons e-assist-copy') {
            this.getClipBoardContent(SanitizeHtmlHelper.sanitize(this.prompts[parseInt(index.toString(), 10)].response));
            args.item.prefixIcon = 'e-icons e-assist-check';
            this.responseToolbarEle.dataBind();
            setTimeout(() => {
                args.item.prefixIcon = 'e-icons e-assist-copy';
                this.responseToolbarEle.dataBind();
            }, 1000);
        }
        const icon = args.item.prefixIcon;
        const isLikeInteracted = icon === 'e-icons e-assist-like-filled' || icon === 'e-icons e-assist-like';
        const isDislikeInteracted = icon === 'e-icons e-assist-dislike-filled' || icon === 'e-icons e-assist-dislike';
        if (isLikeInteracted || isDislikeInteracted) {
            let isHelpful = null;
            if (isLikeInteracted) {
                isHelpful = this.prompts[parseInt(index.toString(), 10)].isResponseHelpful === true ? null : true;
            }
            else if (isDislikeInteracted) {
                isHelpful = this.prompts[parseInt(index.toString(), 10)].isResponseHelpful === false ? null : false;
            }
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.prompts[parseInt(index.toString(), 10)].isResponseHelpful = isHelpful;
            const promptItem = this.prompts[parseInt(index.toString(), 10)];
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            const controlParentItems = args.item.controlParent.items;
            const likeIndex = controlParentItems.findIndex((it) => it.prefixIcon === 'e-icons e-assist-like' || it.prefixIcon === 'e-icons e-assist-like-filled');
            const dislikeIndex = controlParentItems.findIndex((it) => it.prefixIcon === 'e-icons e-assist-dislike' || it.prefixIcon === 'e-icons e-assist-dislike-filled');
            if (isLikeInteracted) {
                if (promptItem.isResponseHelpful === true) {
                    args.item.prefixIcon = 'e-icons e-assist-like-filled';
                    if (controlParentItems && controlParentItems.length > 2) {
                        controlParentItems[parseInt(dislikeIndex.toString(), 10)].prefixIcon = 'e-icons e-assist-dislike';
                    }
                }
                else {
                    args.item.prefixIcon = 'e-icons e-assist-like';
                }
            }
            else if (isDislikeInteracted) {
                if (promptItem.isResponseHelpful === false) {
                    args.item.prefixIcon = 'e-icons e-assist-dislike-filled';
                    if (controlParentItems && controlParentItems.length > 1) {
                        controlParentItems[parseInt(likeIndex.toString(), 10)].prefixIcon = 'e-icons e-assist-like';
                    }
                }
                else {
                    args.item.prefixIcon = 'e-icons e-assist-dislike';
                }
            }
            this.responseToolbarEle.dataBind();
            this.isProtectedOnChange = prevOnChange;
        }
    }
    renderPrompt(promptText, promptIndex, attachedFiles) {
        const outputPrompt = this.createElement('div', { attrs: { class: 'e-prompt-text', tabindex: '0' } });
        const promptFiles = this.createElement('div', { attrs: { class: 'e-prompt-uploaded-files' } });
        const promptContent = this.createElement('div', { className: 'e-prompt-content' });
        const promptDetails = this.createElement('div', { className: 'e-prompt-details' });
        const promptToolbarContainer = this.createElement('div', { className: 'e-prompt-toolbar' });
        const promptToolbar = this.createElement('div');
        const userIcon = this.createElement('span', { className: this.promptIconCss ? 'e-prompt-icon e-icons '
                + this.promptIconCss : '' });
        if (this.promptItemTemplate) {
            this.getContextObject('promptItemTemplate', this.outputSuggestionEle, promptIndex);
        }
        else {
            outputPrompt.innerHTML = promptText;
            const uploadedFiles = attachedFiles || this.uploadedFiles;
            if (uploadedFiles.length > 0) {
                uploadedFiles.forEach((file) => {
                    promptFiles.appendChild(this.createFileItem(file, false));
                });
                promptDetails.appendChild(promptFiles);
            }
            if (promptText.length > 0) {
                promptDetails.appendChild(outputPrompt);
            }
            promptContent.appendChild(promptDetails);
            if (this.promptIconCss) {
                promptContent.appendChild(userIcon);
            }
            this.outputSuggestionEle.append(promptContent);
        }
        this.renderPromptToolbar(promptToolbar, promptIndex);
        promptToolbarContainer.append(promptToolbar);
        this.appendChildren(this.outputSuggestionEle, promptToolbarContainer);
    }
    renderPromptToolbar(element, promptIndex) {
        let pushToolbar = [];
        if (this.promptToolbarSettings.items.length === 0) {
            pushToolbar = [
                { prefixIcon: 'e-icons e-assist-edit', tooltipText: 'Edit' },
                { prefixIcon: 'e-icons e-assist-copy', tooltipText: 'Copy' }
            ];
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.promptToolbarSettings.items = [
                { iconCss: 'e-icons e-assist-edit', tooltip: 'Edit' },
                { iconCss: 'e-icons e-assist-copy', tooltip: 'Copy' }
            ];
            this.isProtectedOnChange = prevOnChange;
        }
        else {
            pushToolbar = this.promptToolbarSettings.items.map((item) => ({
                type: item.type,
                template: item.template,
                disabled: item.disabled,
                cssClass: item.cssClass,
                visible: item.visible,
                tooltipText: item.tooltip,
                prefixIcon: item.iconCss,
                text: item.text,
                align: item.align,
                width: this.promptToolbarSettings.width,
                tabIndex: item.tabIndex
            }));
        }
        this.promptToolbarEle = new Toolbar({
            items: pushToolbar,
            clicked: (args) => {
                const eventItemArgs = {
                    type: args.item.type,
                    text: args.item.text,
                    iconCss: args.item.prefixIcon,
                    cssClass: args.item.cssClass,
                    tooltip: args.item.tooltipText,
                    template: args.item.template,
                    disabled: args.item.disabled,
                    visible: args.item.visible,
                    align: args.item.align,
                    tabIndex: args.item.tabIndex
                };
                const eventArgs = {
                    item: eventItemArgs,
                    event: args.originalEvent,
                    cancel: false,
                    dataIndex: promptIndex
                };
                if (this.promptToolbarSettings.itemClicked) {
                    this.promptToolbarSettings.itemClicked.call(this, eventArgs);
                }
                if (!eventArgs.cancel) {
                    if (args.item.prefixIcon === 'e-icons e-assist-edit') {
                        this.onEditIconClick(promptIndex);
                    }
                    if (args.item.prefixIcon === 'e-icons e-assist-copy') {
                        this.getClipBoardContent(SanitizeHtmlHelper.sanitize(this.prompts[parseInt(promptIndex.toString(), 10)].prompt));
                        args.item.prefixIcon = 'e-icons e-assist-check';
                        this.promptToolbarEle.dataBind();
                        setTimeout(() => {
                            args.item.prefixIcon = 'e-icons e-assist-copy';
                            this.promptToolbarEle.dataBind();
                        }, 1000);
                    }
                }
            }
        });
        this.promptToolbarEle.appendTo(element);
        this.promptToolbarEle.element.setAttribute('aria-label', `prompt-toolbar-${promptIndex}`);
    }
    renderSkeleton() {
        this.skeletonContainer = this.createElement('div', { className: 'e-output-container' });
        const outputViewWrapper = this.createElement('div', { className: 'e-output', styles: 'width: 70%;' });
        const skeletonIconEle = this.createElement('span', { className: 'e-output-icon e-skeleton e-skeleton-text e-shimmer-wave' });
        const skeletonBodyEle = this.createElement('div', { className: 'e-loading-body' });
        const skeletonFooterEle = this.createElement('div', { className: 'e-loading-footer' });
        const [skeletonLine1, skeletonLine2, skeletonLine3] = [
            this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 100%; height: 15px;' }),
            this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 75%; height: 15px;' }),
            this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 50%; height: 15px;' })
        ];
        const [footerSkeleton] = [
            this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 100%; height: 30px;' })
        ];
        this.appendChildren(skeletonBodyEle, skeletonLine1, skeletonLine2, skeletonLine3);
        skeletonFooterEle.append(footerSkeleton);
        this.appendChildren(outputViewWrapper, skeletonBodyEle, skeletonFooterEle);
        this.appendChildren(this.skeletonContainer, skeletonIconEle, outputViewWrapper);
    }
    onEditIconClick(promptIndex) {
        if (this.editableTextarea) {
            if (this.suggestionsElement) {
                this.suggestionsElement.hidden = true;
            }
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.editableTextarea.innerHTML = this.prompt =
                SanitizeHtmlHelper.sanitize(this.prompts[parseInt(promptIndex.toString(), 10)].prompt);
            this.isProtectedOnChange = prevOnChange;
            this.refreshTextareaUI();
            this.editableTextarea.focus();
            this.setFocusAtEnd(this.editableTextarea);
            this.pushToUndoStack(this.prompt);
            this.redoStack = [];
        }
    }
    refreshTextareaUI() {
        this.updateHiddenTextarea(this.prompt);
        this.checkAndActivateSendIcon();
        this.updateFooterElementClass();
        this.updateFooterType(this.footerToolbarSettings.toolbarPosition);
        this.toggleClearIcon();
    }
    checkAndActivateSendIcon() {
        if (!this.footerToolbarEle) {
            return;
        }
        const length = this.prompt.length > 0 ? this.prompt.length : this.uploadedFiles.length;
        if (this.sendToolbarItem.prefixIcon === 'e-icons e-assist-send') {
            const sendItem = this.footerToolbarEle.element.querySelector('.e-assist-send');
            if (sendItem) {
                if (length > 0) {
                    removeClass([sendItem], 'disabled');
                    sendItem.setAttribute('title', this.l10n.getConstant('send'));
                }
                else {
                    addClass([sendItem], 'disabled');
                }
            }
        }
    }
    toggleClearIcon() {
        if (this.clearToolbarItem && this.footerToolbarEle) {
            const isFocused = document.activeElement === this.editableTextarea;
            const hasContent = this.editableTextarea.textContent.length > 0;
            const clearItemElement = this.footerToolbarEle.element.querySelector('.e-toolbar-item .e-icons.e-assist-clear-icon')
                .closest('.e-toolbar-item');
            if (clearItemElement) {
                if (isFocused && hasContent) {
                    this.footerToolbarEle.hideItem(clearItemElement, false);
                }
                else {
                    this.footerToolbarEle.hideItem(clearItemElement, true);
                }
            }
        }
    }
    updateIcons(newCss, isPromptIconCss = false) {
        let elements;
        if (this.outputElement) {
            if (isPromptIconCss) {
                newCss = 'e-prompt-icon e-icons ' + newCss;
                elements = this.outputElement.querySelectorAll('.e-prompt-icon');
            }
            else {
                newCss = ' e-output-icon e-icons ' + newCss;
                elements = this.outputElement.querySelectorAll('.e-output-icon');
            }
        }
        for (let index = 0; index < (elements && elements.length); index++) {
            removeClass([elements[parseInt(index.toString(), 10)]], elements[parseInt(index.toString(), 10)].classList.toString().trim().split(' '));
            addClass([elements[parseInt(index.toString(), 10)]], newCss.trim().split(' '));
        }
    }
    updateToolbarSettings(previousToolbar) {
        const previousToolbarIndex = 0;
        for (let index = this.views.length; index < this.toolbarItems.length; index++) {
            if (previousToolbar.items[parseInt(previousToolbarIndex.toString(), 10)] === this.toolbarItems[parseInt(index.toString(), 10)]) {
                this.toolbarItems.splice(index, 1);
            }
        }
        this.updateHeaderToolbar();
        this.toolbar.items = this.toolbarItems;
    }
    updateAttachmentToolbarItemInSettings() {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        const items = this.footerToolbarSettings.items;
        const attachmentItemIndex = items.findIndex((item) => item.iconCss === 'e-icons e-assist-attachment-icon');
        if (this.enableAttachments && attachmentItemIndex === -1) {
            const attachmentItem = {
                iconCss: 'e-icons e-assist-attachment-icon',
                tooltip: this.l10n.getConstant('attachments'),
                align: 'Right'
            };
            const sendItemIndex = items.findIndex((item) => item.iconCss === 'e-icons e-assist-send');
            items.splice(sendItemIndex !== -1 ? sendItemIndex : items.length, 0, attachmentItem);
        }
        else if (!this.enableAttachments && attachmentItemIndex !== -1) {
            items.splice(attachmentItemIndex, 1);
        }
        this.isProtectedOnChange = prevOnChange;
    }
    updateClearToolbarItemInSettings() {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        const items = this.footerToolbarSettings.items;
        const clearItemIndex = items.findIndex((item) => item.iconCss === 'e-icons e-assist-clear-icon');
        if (this.showClearButton && clearItemIndex === -1) {
            const clearItem = {
                iconCss: 'e-icons e-assist-clear-icon',
                tooltip: this.l10n.getConstant('clear'),
                align: 'Right'
            };
            const sendItemIndex = items.findIndex((item) => item.iconCss === 'e-icons e-assist-send');
            items.splice(sendItemIndex !== -1 ? sendItemIndex : items.length, 0, clearItem);
        }
        else if (!this.showClearButton && clearItemIndex !== -1) {
            items.splice(clearItemIndex, 1);
        }
        this.isProtectedOnChange = prevOnChange;
    }
    updateFooterToolbar() {
        const footerIconsWrapper = this.footer.querySelector('.e-footer-icons-wrapper');
        if (footerIconsWrapper) {
            footerIconsWrapper.innerHTML = '';
            this.footerToolbarEle = null;
            this.sendToolbarItem = null;
            this.clearToolbarItem = null;
            this.attachmentToolbarItem = null;
            this.renderFooterToolbar(footerIconsWrapper);
            this.refreshTextareaUI();
        }
    }
    updateResponse(response, index, isFinalUpdate, responseItem) {
        if (!this.responseItemTemplate && responseItem) {
            const outputEle = responseItem.querySelector('.e-output');
            const outputContentBodyEle = responseItem.querySelector('.e-content-body');
            if (outputContentBodyEle) {
                outputContentBodyEle.innerHTML = response;
            }
            if (isFinalUpdate && this.suggestionsElement) {
                this.suggestionsElement.hidden = false;
            }
            if (isFinalUpdate) {
                this.renderPreTag(outputContentBodyEle);
            }
            if (isFinalUpdate && outputEle.querySelector('.e-content-footer') === null) {
                this.renderOutputToolbarItems(index, isFinalUpdate);
                this.appendChildren(outputEle, this.contentFooterEle);
            }
        }
        else {
            this.renderOutputContainer(undefined, response, undefined, index, false, isFinalUpdate);
        }
    }
    streamResponse(response, index) {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        let i = 0;
        const words = response.split(' ');
        const wordCount = words.length;
        let lastResponse = '';
        const streamingResponse = () => {
            if (this.isOutputRenderingStop) {
                return;
            }
            if (index >= this.prompts.length) {
                return;
            }
            const responseItem = this.element.querySelector(`#e-response-item_${index}`);
            lastResponse += (i === 0 ? '' : ' ') + words[parseInt(i.toString(), 10)];
            i++;
            if (this.outputElement.querySelector('.e-skeleton')) {
                this.outputElement.removeChild(this.skeletonContainer);
            }
            this.updateResponse(lastResponse, index, i === wordCount, responseItem);
            this.scrollToBottom();
            this.setupViewportFilling();
            if (i < wordCount) {
                setTimeout(() => {
                    streamingResponse();
                }, 15);
            }
            else {
                const isFinalUpdate = lastResponse.length === response.length;
                if (isFinalUpdate && this.hasStopResponseButton()) {
                    this.toggleStopRespondingButton(false);
                }
                this.isResponseRequested = !isFinalUpdate;
            }
        };
        streamingResponse();
        this.isProtectedOnChange = prevOnChange;
    }
    updateBannerTemplate(newTemplate) {
        if (!isNOU(newTemplate)) {
            const contentContainer = this.element.querySelector('.e-view-container');
            const existingTemplate = contentContainer.querySelector('.e-banner-view');
            if (existingTemplate) {
                existingTemplate.remove();
            }
            this.updateBannerView(contentContainer);
        }
    }
    updatePromptSuggestionTemplate() {
        if (this.suggestionsElement) {
            this.suggestionsElement.remove();
        }
        if (!this.isOutputRenderingStop) {
            this.renderSuggestions(this.promptSuggestions, this.promptSuggestionsHeader, this.promptSuggestionItemTemplate, 'promptSuggestion', 'promptSuggestionItemTemplate', this.onSuggestionClick);
        }
    }
    updateFooterTemplate() {
        this.footer.innerHTML = '';
        this.updateFooterClass(this.footerTemplate);
        this.unWireFooterEvents(this.footerTemplate);
        this.renderAssistViewFooter();
        if (!this.footerTemplate) {
            this.wireFooterEvents(this.footerTemplate);
        }
    }
    updateAttachmentSettings(newAttachment) {
        if (!isNOU(newAttachment.allowedFileTypes)) {
            this.uploaderObj.allowedExtensions = newAttachment.allowedFileTypes;
        }
        if (!isNOU(newAttachment.maxFileSize)) {
            this.uploaderObj.maxFileSize = newAttachment.maxFileSize;
        }
        this.uploaderObj.asyncSettings = {
            saveUrl: !isNOU(newAttachment.saveUrl) ? newAttachment.saveUrl : this.uploaderObj.asyncSettings.saveUrl,
            removeUrl: !isNOU(newAttachment.removeUrl) ? newAttachment.removeUrl : this.uploaderObj.asyncSettings.removeUrl
        };
    }
    handleSTTDynamicChange(newProp, oldProp) {
        if (oldProp.enable !== newProp.enable) {
            this.updateFooterToolbar();
            this.updateSpeechToTextSettings(newProp);
        }
        if (isNOU(this.speechToTextObj)) {
            return;
        }
        if (oldProp.allowInterimResults !== newProp.allowInterimResults) {
            this.speechToTextObj.allowInterimResults = newProp.allowInterimResults;
        }
        if (oldProp.buttonSettings !== newProp.buttonSettings) {
            this.speechToTextObj.buttonSettings = newProp.buttonSettings;
        }
        if (oldProp.tooltipSettings !== newProp.tooltipSettings) {
            this.speechToTextObj.tooltipSettings = newProp.tooltipSettings;
        }
        if (oldProp.showTooltip !== newProp.showTooltip) {
            this.speechToTextObj.showTooltip = newProp.showTooltip;
        }
        if (oldProp.cssClass !== newProp.cssClass) {
            this.speechToTextObj.cssClass = newProp.cssClass;
        }
        if (oldProp.disabled !== newProp.disabled) {
            this.speechToTextObj.disabled = newProp.disabled;
        }
        if (oldProp.lang !== newProp.lang) {
            this.speechToTextObj.lang = newProp.lang;
        }
        if (oldProp.listeningState !== newProp.listeningState) {
            this.speechToTextObj.listeningState = newProp.listeningState;
        }
        this.speechToTextObj.dataBind();
    }
    updateSpeechToTextSettings(newProps) {
        this.renderSpeechToText();
        if (this.speechToTextObj == null) {
            return;
        }
        this.speechToTextObj.allowInterimResults = newProps.allowInterimResults;
        this.speechToTextObj.transcript = newProps.transcript;
        if (!isNOU(newProps.lang)) {
            this.speechToTextObj.lang = newProps.lang || 'en-US';
        }
        if (!isNOU(newProps.disabled)) {
            this.speechToTextObj.disabled = newProps.disabled;
        }
        if (!isNOU(newProps.buttonSettings)) {
            this.speechToTextObj.buttonSettings = newProps.buttonSettings;
        }
        if (!isNOU(newProps.showTooltip)) {
            this.speechToTextObj.showTooltip = newProps.showTooltip;
        }
        if (!isNOU(newProps.tooltipSettings)) {
            this.speechToTextObj.tooltipSettings = newProps.tooltipSettings;
        }
        if (!isNOU(newProps.cssClass)) {
            this.speechToTextObj.cssClass = newProps.cssClass;
        }
    }
    updateLocale() {
        // Update file upload failure locale
        this.l10n.setLocale(this.locale);
        const failureElement = this.viewWrapper.querySelector('.e-upload-failure-alert');
        if (failureElement) {
            const failureMessageEle = failureElement.querySelector('.e-failure-message');
            if (failureMessageEle.classList.contains('e-size-failure')) {
                failureMessageEle.textContent = this.l10n.getConstant('fileSizeFailure');
            }
            else {
                let failureText = this.l10n.getConstant('fileCountFailure');
                failureText = failureText.replace('{0}', this.attachmentSettings.maximumCount.toString());
                if (this.attachmentSettings.maximumCount === 1) {
                    failureText = failureText.replace('files', 'file');
                }
                failureMessageEle.textContent = failureText;
            }
        }
    }
    destroy() {
        super.destroy();
        this.unWireEvents();
        this.destroyAndNullify(this.responseToolbarEle);
        this.destroyAndNullify(this.promptToolbarEle);
        this.destroyAndNullify(this.footerToolbarEle);
        this.destroyAndNullify(this.downArrowIcon);
        this.destroyAndNullify(this.toolbar);
        this.destroyAndNullify(this.speechToTextObj);
        this.destroyAssistView();
        //private html elements nullify
        remove(this.viewWrapper);
        this.viewWrapper = null;
        this.aiAssistViewRendered = null;
        this.assistViewTemplateIndex = null;
        this.toolbarItems = [];
        this.displayContents = [];
        this.isOutputRenderingStop = null;
        this.isResponseRequested = null;
        this.suggestionHeader = null;
        this.previousElement = null;
        this.assistCustomSection = null;
        this.speechToTextToolbarItem = null;
        this.preTagElements = [];
        // properties nullify
        this.toolbarSettings = this.promptToolbarSettings = this.responseToolbarSettings = {};
        if (this.cssClass) {
            removeClass([this.element], this.cssClass.split(' '));
        }
        this.element.classList.remove('e-rtl');
    }
    destroyAssistView() {
        const properties = [
            'toolbarHeader',
            'sendIcon',
            'clearIcon',
            'suggestions',
            'skeletonContainer',
            'outputElement',
            'outputSuggestionEle',
            'contentFooterEle',
            'editableTextarea',
            'footer',
            'speechToTextToolbarItem',
            'assistCustomSection',
            'content',
            'stopResponding',
            'contentWrapper'
        ];
        for (const prop of properties) {
            const element = prop;
            this.removeAndNullify(this[element]);
            this[element] = null;
        }
    }
    /**
     * Executes the specified prompt in the AIAssistView component. The method accepts a string representing the prompt.
     *
     * @param {string} prompt - The prompt text to be executed. It must be a non-empty string.
     *
     * @returns {void}
     */
    executePrompt(prompt) {
        if (!isNOU(prompt) && prompt.trim().length > 0) {
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.prompt = prompt;
            this.isProtectedOnChange = prevOnChange;
            this.onSendIconClick();
        }
    }
    /**
     * Adds a response to the last prompt or appends a new prompt data in the AIAssistView component.
     *
     * @param {string | Object} outputResponse - The response to be added. Can be a string representing the response or an object containing both the prompt and the response.
     * - If `outputResponse` is a string, it updates the response for the last prompt in the prompts collection.
     * - If `outputResponse` is an object, it can either update the response of an existing prompt if the prompt matches or append a new prompt data.
     * @param {boolean} isFinalUpdate - Indicates whether this response is the final one, to hide the stop response button.
     * @returns {void}
     */
    addPromptResponse(outputResponse, isFinalUpdate = true) {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        if (!this.isOutputRenderingStop) {
            const responseItem = this.element.querySelector(`#e-response-item_${this.prompts.length - 1}`);
            let lastPrompt = this.prompts[this.prompts.length - 1];
            const processResponse = (rawResponse) => {
                if (this.enableStreaming) {
                    isFinalUpdate = false;
                    const htmlResponse = MarkdownConverter.toHtml(rawResponse);
                    lastPrompt.response = htmlResponse;
                    this.streamResponse(lastPrompt.response, this.prompts.length - 1);
                }
                else {
                    lastPrompt.response = rawResponse;
                    this.updateResponse(lastPrompt.response, this.prompts.length - 1, isFinalUpdate, responseItem);
                }
            };
            if (typeof outputResponse === 'string') {
                if (!this.isResponseRequested) {
                    this.prompts = [...this.prompts, { prompt: null, response: null, isResponseHelpful: null, attachedFiles: null }];
                    lastPrompt = this.prompts[this.prompts.length - 1];
                }
                processResponse(outputResponse);
            }
            if (typeof outputResponse === 'object') {
                const tPrompt = {
                    prompt: outputResponse.prompt,
                    attachedFiles: outputResponse.attachedFiles,
                    response: outputResponse.response,
                    isResponseHelpful: isNOU(outputResponse.isResponseHelpful) ? null :
                        outputResponse.isResponseHelpful
                };
                if (this.prompt === tPrompt.prompt || this.lastStreamPrompt === tPrompt.prompt) {
                    lastPrompt.attachedFiles = tPrompt.attachedFiles;
                    lastPrompt.isResponseHelpful = tPrompt.isResponseHelpful;
                    processResponse(tPrompt.response);
                }
                else {
                    this.prompts = [...this.prompts, tPrompt];
                    this.renderOutputContainer(tPrompt.prompt, tPrompt.response, tPrompt.attachedFiles, this.prompts.length - 1, true, isFinalUpdate);
                }
                if (!isFinalUpdate) {
                    this.lastStreamPrompt = tPrompt.prompt;
                }
            }
            if (isFinalUpdate) {
                this.setupViewportFilling();
            }
            if (!this.enableStreaming) {
                if (isFinalUpdate && this.hasStopResponseButton()) {
                    this.toggleStopRespondingButton(false);
                }
                this.isResponseRequested = !isFinalUpdate;
            }
        }
        this.isProtectedOnChange = prevOnChange;
        if (this.enableScrollToBottom && this.downArrowIcon && this.outputContentBodyEle && this.contentWrapper) {
            this.downArrowIcon.visible = this.outputContentBodyEle.scrollHeight > this.contentWrapper.clientHeight;
        }
    }
    /**
     * Scrolls the view to the bottom to display the most recent response in the AIAssistView component.
     *
     * This method programmatically scrolls the view to the bottom,
     * typically used when new responses are added or to refocus on the latest response.
     *
     * @returns {void}
     */
    scrollToBottom() {
        this.updateScroll(this.contentWrapper);
    }
    /**
     * Called if any of the property value is changed.
     *
     * @param  {AIAssistViewModel} newProp - Specifies new properties
     * @param  {AIAssistViewModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    onPropertyChanged(newProp, oldProp) {
        for (const prop of Object.keys(newProp)) {
            switch (prop) {
                case 'width':
                case 'height':
                    this.setDimension(this.element, this.width, this.height);
                    break;
                case 'cssClass':
                    this.updateCssClass(this.element, newProp.cssClass, oldProp.cssClass);
                    break;
                case 'promptIconCss':
                    this.updateIcons(newProp.promptIconCss, true);
                    break;
                case 'responseIconCss':
                    this.updateIcons(newProp.responseIconCss);
                    break;
                case 'showHeader':
                    this.updateHeader(this.showHeader, this.toolbarHeader, this.viewWrapper);
                    break;
                case 'promptSuggestions':
                    this.updatePromptSuggestionTemplate();
                    break;
                case 'showClearButton':
                    if (this.footerTemplate) {
                        return;
                    }
                    else {
                        this.updateClearToolbarItemInSettings();
                        this.updateFooterToolbar();
                    }
                    break;
                case 'promptPlaceholder':
                    this.updatePlaceholder(this.promptPlaceholder);
                    break;
                case 'promptSuggestionsHeader': {
                    this.suggestionHeader.innerHTML = this.promptSuggestionsHeader;
                    const suggestionHeaderElem = this.element.querySelector('.e-suggestions .e-suggestion-header');
                    if (!suggestionHeaderElem) {
                        this.suggestionsElement.append(this.suggestionHeader);
                    }
                    break;
                }
                case 'activeView': {
                    const previousViewIndex = this.getIndex(oldProp.activeView);
                    this.updateActiveView(previousViewIndex);
                    break;
                }
                case 'enableRtl':
                    this.element.classList[this.enableRtl ? 'add' : 'remove']('e-rtl');
                    if (!isNOU(this.toolbar)) {
                        this.toolbar.enableRtl = this.enableRtl;
                        this.toolbar.dataBind();
                    }
                    break;
                case 'toolbarSettings':
                    this.updateToolbarSettings(oldProp.toolbarSettings);
                    break;
                case 'footerToolbarSettings':
                    if (newProp.footerToolbarSettings.items) {
                        this.updateFooterToolbar();
                    }
                    if (newProp.footerToolbarSettings.toolbarPosition) {
                        this.updateFooterType(newProp.footerToolbarSettings.toolbarPosition);
                    }
                    break;
                case 'promptToolbarSettings':
                case 'responseToolbarSettings':
                case 'prompts':
                    this.isOutputRenderingStop = false;
                    if (this.outputElement) {
                        remove(this.outputElement);
                    }
                    if (this.hasStopResponseButton()) {
                        this.toggleStopRespondingButton(false);
                    }
                    this.aiAssistViewRendered = false;
                    this.latestResponseMinHeight = null;
                    this.renderOutputContent(true);
                    this.detachCodeCopyEventHandler();
                    if (this.bannerTemplate) {
                        this.updateBannerTemplate(this.bannerTemplate);
                    }
                    this.checkIsScrollable();
                    this.setupViewportFilling();
                    break;
                case 'prompt':
                    if (!this.footerTemplate) {
                        this.editableTextarea.innerText = this.prompt;
                        this.refreshTextareaUI();
                        this.pushToUndoStack(this.prompt);
                    }
                    break;
                case 'locale':
                    this.updateLocale();
                    break;
                case 'bannerTemplate': {
                    this.updateBannerTemplate(newProp.bannerTemplate);
                    break;
                }
                case 'promptSuggestionItemTemplate': {
                    if (!isNOU(newProp.promptSuggestionItemTemplate)) {
                        this.updatePromptSuggestionTemplate();
                    }
                    break;
                }
                case 'footerTemplate': {
                    this.updateFooterTemplate();
                    break;
                }
                case 'enableStreaming': {
                    this.enableStreaming = newProp.enableStreaming;
                    break;
                }
                case 'enableAttachments': {
                    if (!this.footerTemplate) {
                        this.updateAttachmentToolbarItemInSettings();
                        this.updateFooterToolbar();
                    }
                    break;
                }
                case 'enableScrollToBottom': {
                    if (this.enableScrollToBottom) {
                        this.bindScroll();
                    }
                    else {
                        this.unBindScroll();
                    }
                    break;
                }
                case 'attachmentSettings':
                    this.updateAttachmentSettings(newProp.attachmentSettings);
                    break;
                case 'speechToTextSettings':
                    this.handleSTTDynamicChange(newProp.speechToTextSettings, oldProp.speechToTextSettings);
                    break;
            }
        }
    }
};
__decorate([
    Property('')
], AIAssistView.prototype, "prompt", void 0);
__decorate([
    Property('Type prompt for assistance...')
], AIAssistView.prototype, "promptPlaceholder", void 0);
__decorate([
    Collection([], Prompt)
], AIAssistView.prototype, "prompts", void 0);
__decorate([
    Property([])
], AIAssistView.prototype, "promptSuggestions", void 0);
__decorate([
    Property('')
], AIAssistView.prototype, "promptSuggestionsHeader", void 0);
__decorate([
    Property(true)
], AIAssistView.prototype, "showHeader", void 0);
__decorate([
    Complex({ items: [] }, ToolbarSettings)
], AIAssistView.prototype, "toolbarSettings", void 0);
__decorate([
    Property(0)
], AIAssistView.prototype, "activeView", void 0);
__decorate([
    Property(null)
], AIAssistView.prototype, "promptIconCss", void 0);
__decorate([
    Property(null)
], AIAssistView.prototype, "responseIconCss", void 0);
__decorate([
    Property('100%')
], AIAssistView.prototype, "width", void 0);
__decorate([
    Property('100%')
], AIAssistView.prototype, "height", void 0);
__decorate([
    Property('')
], AIAssistView.prototype, "cssClass", void 0);
__decorate([
    Collection([], AssistView)
], AIAssistView.prototype, "views", void 0);
__decorate([
    Complex({ width: null, items: [] }, PromptToolbarSettings)
], AIAssistView.prototype, "promptToolbarSettings", void 0);
__decorate([
    Complex({ width: null, items: [] }, ResponseToolbarSettings)
], AIAssistView.prototype, "responseToolbarSettings", void 0);
__decorate([
    Complex({ toolbarPosition: 'Inline', items: [] }, FooterToolbarSettings)
], AIAssistView.prototype, "footerToolbarSettings", void 0);
__decorate([
    Complex({ enable: false }, SpeechToTextSettings)
], AIAssistView.prototype, "speechToTextSettings", void 0);
__decorate([
    Property(false)
], AIAssistView.prototype, "enableAttachments", void 0);
__decorate([
    Complex({ saveUrl: '', removeUrl: '', maxFileSize: 2000000, allowedFileTypes: '', maximumCount: 10 }, AttachmentSettings)
], AIAssistView.prototype, "attachmentSettings", void 0);
__decorate([
    Property(false)
], AIAssistView.prototype, "showClearButton", void 0);
__decorate([
    Property(true)
], AIAssistView.prototype, "enableScrollToBottom", void 0);
__decorate([
    Property('')
], AIAssistView.prototype, "footerTemplate", void 0);
__decorate([
    Property('')
], AIAssistView.prototype, "promptItemTemplate", void 0);
__decorate([
    Property('')
], AIAssistView.prototype, "responseItemTemplate", void 0);
__decorate([
    Property('')
], AIAssistView.prototype, "promptSuggestionItemTemplate", void 0);
__decorate([
    Property('')
], AIAssistView.prototype, "bannerTemplate", void 0);
__decorate([
    Event()
], AIAssistView.prototype, "promptRequest", void 0);
__decorate([
    Event()
], AIAssistView.prototype, "promptChanged", void 0);
__decorate([
    Event()
], AIAssistView.prototype, "stopRespondingClick", void 0);
__decorate([
    Event()
], AIAssistView.prototype, "beforeAttachmentUpload", void 0);
__decorate([
    Event()
], AIAssistView.prototype, "attachmentUploadSuccess", void 0);
__decorate([
    Event()
], AIAssistView.prototype, "attachmentUploadFailure", void 0);
__decorate([
    Event()
], AIAssistView.prototype, "attachmentRemoved", void 0);
AIAssistView = __decorate([
    NotifyPropertyChanges
], AIAssistView);
export { AIAssistView };
